export enum ViewModes  {
  USERS = 'users',
  CUSTOMERS = 'customers'
}

export enum CustomerViewModes {
  LIST,
  REPORT
}
